<template>
  <v-container fluid>
    <!-- Top Bar -->
    <v-row class="mb-4">
      <v-col cols="6" class="d-flex align-center py-0">
        <!-- Search -->
        <!-- <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="Search drivers..."
          dense
          outlined
          hide-details
          solo
          flat
          class="mr-4"
        ></v-text-field> -->

        <!-- Status Filter -->
        <!-- <v-select
          v-model="statusFilter"
          :items="statusOptions"
          placeholder="All Status"
          dense
          outlined
          hide-details
          solo
          flat
          class="mr-4"
        ></v-select> -->
      </v-col>
      <v-col cols="6" class="d-flex align-center justify-end pt-0">
        <!-- Buttons -->
        <template v-if="selected.length">
          <v-btn @click="deleteSelected" depressed color="red lighten-5" class="red--text mr-2">
            <span class="font-size-16 font-weight-600">
              <v-icon left color="red darken-2">mdi-delete</v-icon>
              Delete Selected
            </span>
          </v-btn>
          <v-btn @click="movePostalCodesDialog = true" depressed color="orange darken-2" class="white--text">
            <span class="font-size-16 font-weight-600">
              <v-icon left>mdi-swap-horizontal</v-icon>
              Move to Zone
            </span>
          </v-btn>
        </template>
        <template v-else>
          <v-btn depressed small class="mx-4 white--text" v-on:click="importDialogOpen = true" color="cyan">
            <span class="font-size-16 font-weight-600">
              <v-icon left small>mdi-plus</v-icon> Import Postal Codes</span>
          </v-btn>
          <v-card class="d-flex align-center grey lighten-4 rounded-lg px-2 py-2" elevation="0">
            <TextField v-model="postalCodes" placeholder="Enter Postal Codes" dense outlined hide-details solo flat
              class="mr-2" type="number" maxlength="6" counter="6"></TextField>
            <v-btn depressed color="orange darken-2" class="white--text">
              <span class="font-size-16 font-weight-600" @click="addPostalCodes()"> Add </span>
            </v-btn>
          </v-card>
        </template>
      </v-col>
    </v-row>

    <!-- Driver Cards -->
    <perfect-scrollbar :options="{ suppressScrollX: true }" class="scroll custom-box-top-inner-shado"
      style="height: calc(100vh - 250px); position: relative">
      <v-simple-table class="simple-table" fixed-header :height="postalCodesList?.length > 0 ? 'auto' : '100px'">
        <template v-slot:default>
          <thead>
            <tr>
              <!-- <th class="simple-table-th px-2" width="50">
                <v-checkbox v-if="postalCodesList?.length > 0" v-model="selectAll" class="mr-2"
                  hide-details></v-checkbox>
              </th> -->
              <th class="simple-table-th px-2" width="450">Postal Code</th>
              <th class="simple-table-th px-2">Status</th>
              <th class="simple-table-th px-2">Added Date</th>
              <th class="simple-table-th px-2" width="70">Action</th>
            </tr>
          </thead>
          <tbody v-if="postalCodesList?.length > 0">
            <tr v-for="(row, index) in postalCodesList" :key="index" class="alternate-listing-row">
              <!-- <td width="50" class="simple-table-td">
                <v-checkbox v-model="selected" :value="row.id" class="mr-2" hide-details></v-checkbox>
              </td> -->
              <td class="simple-table-td">
                <!-- Show text + pencil when not editing -->
                <template v-if="!row.isEditing">
                  {{ row.postal_code }}
                  <v-icon small color="cyan" size="20" class="ml-2" @click="row.isEditing = true">
                    mdi-pencil
                  </v-icon>
                </template>

                <!-- Show editable text field when editing -->
                <template v-else>
                  <div class="d-flex align-center">
                    <v-text-field v-model="row.postal_code" dense hide-details single-line autofocus class="ma-0" solo
                      flat style="max-width: 100px" @keyup.enter="savePostalCodes(row)"></v-text-field>
                    <v-icon small color="red" size="24" class="ml-2" @click="row.isEditing = false">
                      mdi-close-circle
                    </v-icon>
                    <v-icon small color="green" size="24" class="ml-2" @click="savePostalCodes(row)">
                      mdi-check-circle
                    </v-icon>
                  </div>
                </template>

                <v-edit-dialog v-if="false" :return-value.sync="row.postalCodes" @save="updatePostalCodes(row)"
                  @cancel="cancelEdit(row)" width="200" persistent large>
                  {{ row.postal_code }}
                  <v-icon small color="cyan" size="20" class="ml-2">mdi-pencil</v-icon>

                  <!-- Input field inside dialog -->
                  <template v-slot:input>
                    <v-text-field v-model="row.postal_code" label="Edit Postal Codes" single-line dense hide-details
                      style="max-width: 180px"></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="simple-table-td">
                <v-switch color="blue darken-4" v-model="row.activated" @click="savePostalCodes(row)"></v-switch>
              </td>
              <td class="simple-table-td">{{ formatDate(row?.added_at) }}</td>

              <td class="simple-table-td">
                <v-icon color="red" class="ml-2" size="20" @click="confirmDeletePostalCodes(row)"> mdi-delete</v-icon>
              </td>
            </tr>
          </tbody>
          <tr v-else>
            <td colspan="5" class="py-4">
              <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                Uhh... There are no postal codes at the moment.
              </p>
            </td>
          </tr>
        </template>
      </v-simple-table>
      <ListingFooter :dataLoading="dataLoading" :showingFrom="showingFrom" :showingTo="showingTo" :totalRows="totalRows"
        :currentPage="currentPage" :totalPages="totalPages"></ListingFooter>
    </perfect-scrollbar>

    <!-- Move Drivers to Zone -->
    <Dialog :commonDialog="movePostalCodesDialog" :dialog-width="600">
      <template v-slot:title> Move Postal Codes </template>
      <template v-slot:body>
        <v-container fluid>
          <v-row>
            <v-col md="12">
              <label class="my-auto fw-500 mb-1">Move to Zone</label>

              <v-autocomplete hide-details v-model.trim="zone" :items="zoneList" dense flat filled item-color="cyan"
                color="cyan" solo item-value="id" item-text="name" placeholder="Select Zone" />
            </v-col>
            <v-col md="12">
              <v-card color="grey lighten-4" elevation="0" class="pa-4 rounded-lg">
                <span class="d-block">
                  <strong class="font-weight-600">{{ selected.length }} postal codes</strong>
                  selected for moving
                </span>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn depressed class="mx-2 custom-grey-border custom-bold-button" v-on:click="movePostalCodesDialog = false">
          Close
        </v-btn>
        <v-btn depressed class="mx-2 custom-grey-border custom-bold-button" color="cyan white--text"
          v-on:click="moveSelected">
          Move Postal Codes
        </v-btn>
      </template>
    </Dialog>
    <Dialog :commonDialog="confirmDeleteDialog" :dialog-width="700">
      <template v-slot:title>Are you sure you want to delete the postal code?</template>
      <template v-slot:body>
        <v-container fluid>
          <v-row>

          </v-row>
        </v-container>
      </template>
      <template v-slot:action>
        <v-btn depressed class="mx-2 custom-grey-border custom-bold-button" v-on:click="confirmDeleteDialog = false">
          Close
        </v-btn>
        <v-btn depressed class="mx-2 custom-grey-border custom-bold-button" color="red white--text"
          v-on:click="deletePostalCodes(deletePostalCodeRow)">
          Delete Postal codes
        </v-btn>
      </template>
    </Dialog>

    <ImportTemplate :dialog="importDialogOpen" sample-url="public/import-samples/PostalCodeImport.xlsx"
      :api-url="`postalcode/import/${zoneId}`" title="Import Postal code" v-on:close="importDialogOpen = false"
      @response="handleImportResponse">
    </ImportTemplate>
  </v-container>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH, DELETE, POST, QUERY } from "@/core/services/store/request.module";
import ImportTemplate from "@/view/pages/partials/Import-Template.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import moment from "moment";

export default {
  data() {
    return {
      zone: null,
      postalCodes: null,
      rowsOffset: 0,
      totalPages: 0,
      dataLoading: false,
      confirmDeleteDialog: false,
      currentPage: 1,
      totalRows: 0,
      deletePostalCodeRow: 0,
      importDialogOpen: false,
      postalCodesList: [],
      selectedDrivers: [
        { id: "DRV001", name: "Ahmad Hassan" },
        { id: "DRV002", name: "Lim Teck Wei" },
      ],
      selected: [],
      movePostalCodesDialog: false,
      search: "",
      statusFilter: "All Status",
      statusOptions: ["All Status", "Active", "On Leave"],
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      return moment(date).format("d/m/y");
    },

    handleImportResponse(response) {
      if (response) {
        this.getPostalCodes(this.zoneId);
        this.$emit('refreshZones');
      }

    },
    confirmDeletePostalCodes(row) {
      this.deletePostalCodeRow = row;
      this.confirmDeleteDialog = true;
    },
    deletePostalCodes(row) {
      const _this = this;
      _this.$store
        .dispatch(PATCH, {
          url: "delete-postal-code/" + row.id,
        })
        .then(() => {
          _this.$emit('refreshZones');
          _this.getPostalCodes(this.zoneId);
          _this.confirmDeleteDialog = false;

        })
        .catch((error) => {
          _this.logError(error);
        })

    },

    toggleSelectAll(value) {

      if (value) {
        this.selected = this.postalCodesList.map((item) => item.id);
      } else {

        this.selected = [];
      }
    },


    addPostalCodes() {

      const _this = this;

      let zoneData = {
        zone_id: this.zoneId,
        postalCode: _this.postalCodes
      }
      _this.$store
        .dispatch(PATCH, {
          url: "add-postal-codes",
          data: zoneData,
        })
        .then(() => {
          _this.postalCodes = null;
          _this.getPostalCodes(this.zoneId);
          _this.$emit('refreshZones');
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {

        });
    },

    savePostalCodes(row) {

      row.isEditing = false;
      this.updatePostalCodes(row);

    },

    updatePostalCodes(row) {

      const _this = this;

      _this.$store
        .dispatch(PATCH, {
          url: "update-postal-codes/" + row.id,
          data: row,
        })
        .then(() => {
          _this.$emit('refreshZones');
          _this.getPostalCodes(this.zoneId);

        })
        .catch((error) => {
          _this.logError(error);
        })

    },

    moveSelected() {

      this.$store.dispatch(POST, {
        url: "move-postal-code/" + this.zone,
        data:
        {
          postalIds: this.selected,
        }
      }).then(() => {

        this.selected = [];
        this.$emit('refreshZones');
        this.movePostalCodesDialog = false;
        this.getPostalCodes(this.zoneId);


      }).catch((error) => {
        this.logError(error);
      })

    },
    deleteSelected() {
      const _this = this;
      _this.$store.dispatch(DELETE, {
        url: "delete-postal-codes/" + _this.$route.params.id,
        data:
        {
          postalIds: this.selected
        }
      }).then(() => {
        this.selected = [];
        this.$emit('refreshZones');
        this.getPostalCodes(this.zoneId);

      }).catch((error) => {
        _this.logError(error);
      })
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        console.log("Selected file:", file.name);
      }
    },
    handleDrop(event) {
      const file = event.dataTransfer.files[0];
      if (file) {
        console.log("Dropped file:", file.name);
      }
    },

    getPostalCodes() {
      let requestParams = {
        current_page: this.currentPage
      }
      const _this = this;
      _this.$store.dispatch(QUERY, {
        url: `get-postal-codes/${this.zoneId}`,
        data: requestParams,
      }).then((response) => {
        let data = response.data;
        this.postalCodesList = data.rows;
        this.totalRows = data.total_rows;
        this.currentPage = data.current_page;
        this.rowsOffset = data.offset;
        _this.totalPages = Math.ceil(this.totalRows / 15);
      }).catch((error) => {
        _this.logError(error);
      })

    },

  },

  mounted() {
    let _this = this;
    this.getPostalCodes(this.zoneId);

    PaginationEventBus.$on("update:pagination", (param) => {
      _this.currentPage = param;
      _this.getPostalCodes();
    });

  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination");
  },

  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.postalCodesList) === false
        ? this.rowsOffset + 1
        : 0;
    },
    showingTo() {
      return this.rowsOffset + (this.postalCodesList ? this.postalCodesList.length : 0);
    },
    selectedAll: {
      set(param) {
        this.selectedRows = [];
        if (param && this.postalCodesList.length) {
          for (let i = this.postalCodesList.length - 1; i >= 0; i--) {
            this.selectedRows.push(this.postalCodesList[i].id);
          }
        }
      },
      get() {
        let totalItems = this.postalCodesList.length;
        return totalItems > 0
          ? this.selectedRows?.length === totalItems
          : false;
      },
    },
    selectAll: {
      get() {
        return (
          this.selected.length > 0 &&
          this.selected.length === this.postalCodesList.length
        );
      },
      set(value) {
        this.toggleSelectAll(value);
      },
    },
  },

  props: {

    zoneId: {
      type: Number,
      required: false,
      default: 0
    },

    zoneList: {
      type: Array,
      required: false,
      default: () => []
    }

  },

  watch: {
    zoneId(newVal) {

      if (newVal) {
        this.getPostalCodes(newVal);
      }
    }
  },

  components: {
    Dialog,
    ListingFooter,
    ImportTemplate
  },

};
</script>

<style scoped>
.v-card {
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.upload-container {
  border: 2px dashed #c7c7c7;
  border-radius: 6px;
  text-align: center;
  padding: 40px 20px;
  cursor: pointer;
  background-color: #fff;
  transition: border-color 0.2s ease;
}

.upload-container:hover {
  border-color: #3c4c78;
}

.upload-title {
  font-weight: 600;
  color: #000;
}

.upload-subtitle {
  font-size: 14px;
  color: #6b7280;
}
</style>
